import { useEditor } from '@craftjs/core';

export default function Properties() {
  const { selected } = useEditor(({ events, nodes }) => {
    const [id] = events.selected;

    if (id && id !== 'ROOT') {
      const { [id]: { related: { Properties } = {}, data: { name, parent } } } = nodes
      return {
        selected: {
          id, name, Properties,

          get parent() {
            if (!parent) return null

            const { [parent]: { data: { name } } } = nodes
            return {
              id: parent,
              name,
            }
          },
        },
      }
    }

    return {}
  });

  if (!selected) {
    return null
  }

  const { Properties } = selected
  if (!Properties) {
    return null
  }

  return <Properties />
}
